import OperationalReportPage from './OperationalReportPage';
export default function BrandTradingReportPage(){return <OperationalReportPage kind="brand-trading"/>;}
